<template>
    <div>
        <rkm-modal
            extraLarge
            ref="RkmModal"
            title="Exames solicitados no Atendimento do Ambulatório"
        >
            <rkm-row>
                <rkm-col>

                    <Form
                        :paciente="paciente"
                        :exames="exames"
                        :data="data"
                        :agendamento="agendamento"
                        :verificaAutorizacao="verificaAutorizacao"
                        @handleSelecionado="handleSelecionado"
                        @agendarAmbulatorioAtendimento="agendarAmbulatorioAtendimento"
                        @descartarAmbulatorioAtendimento="descartar"
                    />
                </rkm-col>
            </rkm-row>

            <template v-slot:footer="{cancel}">
                <rkm-button
                    v-if="selecionado"
                    @click="descartarMultiple"
                    color="primary"
                    outline
                >
                    Descartar exames
                </rkm-button>

                <rkm-button
                    v-if="selecionado"
                    @click="multipleAmbulatorioAtendimento"
                    color="primary"
                    :disabled="selecionado && exames.filter(e => e.selecionado).length == 0"
                >
                    Agendar exames
                </rkm-button>

                <rkm-button
                    @click="cancel"
                    color="secondary"
                >
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalPermissao
            ref="RkmModalPermissao"
            @saveModal="saveModal"
            :origem="origem"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase } from '@/mixins'

import Form from './Form'

//Enums
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import motivo from '@/enums/exame-laboratorial/motivo'

// Moment.
import moment from 'moment'

//Components.
import ModalPermissao from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/permissao/Modal'

export default {
    components: { Form, ModalPermissao },
    data: () => ({
        item: null,
        selecionado: false,
        exames: [],
        examesBloqueado: [],
        autoriza: false,
        verifyExame: false,
        supervisorId: null,
        enums: {
            statusAgendamento,
            motivo
        },
        exameBloqueado: {
            exameId: null,
            pacienteId: null,
            valor: null,
            motivoId: null,
        },
        origem: 'ambulatorio',
    }),
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {

            this.setLoading()

            this.repositories.agendamento.getExameAmbulatorioAtendimento({
                paciente_id: this.paciente.id,
            })
                .then(response => {

                    const exames = response.data

                    this.exames = exames.filter(
                        exame => Number(exame.isRascunho) === 0
                    )  

                    if (this.exames.length > 0) {

                        this.showConfirmation(
                            `O paciente possui registro de solicitação de exames laboratoriais no Atendimento
                            do Ambulatório. Deseja visualizar?`,
                            async () => this.$refs.RkmModal.show()
                        )
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        descartar(item) {

            this.showConfirmation(
                `Deseja realmente descartar o exame <strong>${item.exameNome}</strong>?`,
                async () => {

                    this.setLoading()

                    this.repositories.agendamento.descartarExameAmbulatorioAtendimento({
                        ambulatorio_atendimento_id: item.exameItemId,
                        multiple: false,
                    })
                        .then(response => {

                            if (response.data) {

                                const index = this.exames.findIndex((obj => obj.exameItemId == item.exameItemId));

                                this.exames.splice(index, 1)
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            )
        },
        descartarMultiple() {

            this.showConfirmation(
                `Deseja realmente descartar os exames selecionados?`,
                async () => {
                    this.setLoading();

                    try {
                        const response = await this.repositories.agendamento.descartarExameAmbulatorioAtendimento({
                            exames: this.camelObjectKeysToSnakeRecursive(this.exames.filter(exame => exame.selecionado)),
                            multiple: true,
                        });

                        if (response.data) {

                            this.exames = this.exames.filter(exame => !exame.selecionado);
                        }
                    } catch (error) {
                        this.handleError(error);
                    } finally {
                        this.unsetLoading();
                    }
                }
            );
        },
        handleSelecionado(value) {

            this.selecionado = value
        },
        exit() {

            this.$refs.RkmModal.hide()
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
        agendarAmbulatorioAtendimento(item) {

            this.$emit('agendarAmbulatorioAtendimento', item)
            this.$refs.RkmModal.hide()
        },
        multipleAmbulatorioAtendimento() {

            this.verifyExame = false
            let msgExame = ''

            const examesSelecionados = this.exames.filter(e => e.selecionado)

            const examesIncompletos = examesSelecionados.filter(e => !e.exameSiglaExame || !e.exameGrupoTipoId)

            if (examesIncompletos.length > 0) {

                const nomes = examesIncompletos.map(e => e.exameNome)

                this.showAlert(
                    `Para adicionar o(s) exame(s) abaixo é necessário que todas as informações obrigatórias estejam preenchidas. Acesse Parametrização > Exame e preencha as informações.<br><br>${nomes.join('<br>')}`,
                    'Atenção'
                )

                return
            }

            const chavesDuplicadas = examesSelecionados
                .map(e => `${e.exameCodigo}-${e.exameNome}`)
                .filter((chave, index, self) => self.indexOf(chave) !== index)

            if (chavesDuplicadas.length > 0) {

                const nomes = examesSelecionados
                    .filter(e => chavesDuplicadas.includes(`${e.exameCodigo}-${e.exameNome}`))
                    .map(e => e.exameNome)
                    .filter((nome, index, self) => self.indexOf(nome) === index)

                this.showAlert(
                    `Existem exames duplicados selecionados. Selecione apenas um exame de cada para continuar:<br><br>${nomes.join('<br>')}`,
                    'Atenção'
                )

                return
            }

            examesSelecionados.forEach(exame => {

                if (exame.exameSenhaSupervisor) {

                    if (this.autoriza == false && this.verificaAutorizacao == false) {

                        const msg = `O exame <strong>${exame.exameNome}</strong> requer autorização de supervisor para ser incluído.`

                        msgExame = msgExame ? msgExame.concat(`<br><br>${msg}`) : msg

                        this.verifyExame = true
                    }
                }
            })

            const statusIgnorados = [
                this.enums.statusAgendamento.FALTOU,
                this.enums.statusAgendamento.NAO_REALIZADO,
                this.enums.statusAgendamento.AGENDADO,
                this.enums.statusAgendamento.DUPLICIDADE,
                this.enums.statusAgendamento.OUTROS
            ]

            examesSelecionados.filter(e => e.validade !== null && !e.examePermiteRepeticao).forEach(exame => {

                let msgDatasExame = ''

                this.data.model.agendamentos.filter(e => e.pacienteId == this.paciente.id &&
                    e.agendamentoId !== this.agendamento.agendamentoId)
                        .forEach(exameIncluido => {

                            let exameFind = exameIncluido.incluido.find(m => m.codigo == exame.exameCodigo && m.statusId !== this.enums.statusAgendamento.CANCELADO)

                            if (exameFind) {

                                if (!statusIgnorados.includes(exameFind.statusId)) {

                                    let addDay = moment(exameIncluido.data).add(exame.validade, 'days').format('YYYY-MM-DD')

                                    if (moment(addDay).isAfter(this.data.form.dataAtual.split("/").reverse().join("-"))) {

                                        if (this.autoriza == false && this.verificaAutorizacao == false) {

                                            this.dataInformada = exameIncluido.data.split("-").reverse().join("/")
                                            this.horaInicial = exameIncluido.horaInicial.split("-").reverse().join("/")

                                            const data = `<strong>${this.dataInformada}</strong> às <strong>${this.horaInicial}</strong>`

                                            msgDatasExame = msgDatasExame ? msgDatasExame.concat(`, ${data}`) : data

                                            this.verifyExame = true
                                        } else {

                                            if (!this.autoriza) {
                                                this.supervisorId = this.agendamento.supervisorId
                                            }

                                            this.saveExameBloqueado(this.enums.motivo.PRAZO_VALIDADE, exame)
                                        }
                                    }
                                }
                            }
                        })

                if (msgDatasExame) {

                    const msgValidade = `O paciente já possui agendamento para o exame <strong>${exame.exameNome}</strong> dentro do prazo de validade, na(s) seguinte(s) data(s): ${msgDatasExame}`

                    msgExame = msgExame ? msgExame.concat(`<br><br>${msgValidade}`) : msgValidade
                }
            })

            examesSelecionados.filter(e => !e.examePermiteRepeticao).forEach(exame => {

                const quantidadeMaxima = exame.exameQuantidadeMaxima ?? exame.exameQuantidadeMaximaExecucao

                if (quantidadeMaxima === null || quantidadeMaxima === undefined || quantidadeMaxima === 9999) return

                let quantidadeExameAgendado = 0

                this.data.model.agendamentos
                    .filter(e => e.pacienteId == this.paciente.id && e.agendamentoId !== this.agendamento.agendamentoId)
                    .forEach(exameIncluido => {
                        if (exameIncluido.incluido.find(m => m.codigo == exame.exameCodigo)) {
                            quantidadeExameAgendado++
                        }
                    })

                if (quantidadeMaxima <= quantidadeExameAgendado) {

                    if (this.autoriza == false && this.verificaAutorizacao == false) {

                        const msgLimite = `O paciente já atingiu o limite anual para o exame <strong>${exame.exameNome}</strong>.`

                        msgExame = msgExame ? msgExame.concat(`<br><br>${msgLimite}`) : msgLimite

                        this.verifyExame = true
                    } else {

                        if (!this.autoriza) {
                            this.supervisorId = this.agendamento.supervisorId
                        }

                        this.saveExameBloqueado(this.enums.motivo.LIMITE_ANUAL, exame)
                    }
                }
            })

            if (this.verifyExame) {

                if (msgExame) {

                    msgExame = msgExame.concat(`.<br><br>`)
                }

                const confirm = async () => {

                    this.$refs.RkmModalPermissao.open()

                    return false
                }

                const cancel = async () => { this.$emit('handleExit') }

                const msg = `${msgExame} Para continuar é necessário informar os dados do supervisor. Deseja continuar?`

                this.showConfirmation(msg, confirm, cancel)

            } else {

                this.exames.filter(e => e.selecionado).forEach(e => { e.supervisorId = this.supervisorId })

                this.$emit('multipleAmbulatorioAtendimento', this.exames)
                this.$refs.RkmModal.hide()
            }
        },
        saveExameBloqueado(motivo, exame) {

            if (!exame) return

            const exameExistente = this.examesBloqueado.find(e => e.exameId === exame.id);

            if (!exameExistente) {

                this.repositories.agendamento.saveExameBloqueado(this.prepareData(motivo, exame))
                    .then(({ data }) => {

                        this.examesBloqueado.push(data);
                    })
                    .catch(this.handleError)
                    .finally()
            }
        },
        saveModal(supervisorId) {
            this.supervisorId = supervisorId
            this.autoriza = true
            this.multipleAmbulatorioAtendimento()
        },
        prepareData(motivo, exame) {

            const exameBloqueado = this.clone(this.exameBloqueado)

            exameBloqueado.pacienteId = this.paciente.id
            exameBloqueado.exameId = exame.exameId
            exameBloqueado.valor = exame.exameValorSigtap ? exame.exameValorServicoAmbilatorial : exame.exameValor
            exameBloqueado.motivoId = motivo

            return this.camelObjectKeysToSnakeRecursive(exameBloqueado)
        },
    },
    props: {
        paciente: { type: Object, required: true},
        agendamento: { type: Object, required: true},
        data: { type: Object, required: true},
        verificaAutorizacao: { type: Boolean, default: false },
    },
}
</script>

